











import {Component, Prop, Vue} from "vue-property-decorator";
import Editor from '@tinymce/tinymce-vue';

@Component({
  components: {
    Editor
  }
})
export default class RichTextEditor extends Vue {
  @Prop({}) value!:string;
  @Prop({default:"12"}) md!:string;
  apiKey = "8vbcapqkfmc4dn0rgjul71kyelq0vp7rl9tcm65nmdgwlgpz";
  updateValue (value:string) {
    this.$emit('input', value)
  }
}
